export enum PopupStyleTypeEnum {
  DEFAULT = 'DEFAULT',
  FLY_OUT = 'FLY_OUT',
  TOP_CENTER = 'TOP_CENTER',
  FULL_PAGE = 'FULL_PAGE',
}
